<script>
import Txplayer from 'Txplayer';
import { mapGetters, mapActions } from 'vuex';
import { CONFIG } from '@/utils/env';
import {
  MENU_KEY,
  DEFAULT_IMG,
  MOD_CLASSIFY,
  CARD_INFO_PARAMS,
  CONTENT_TYPE_MOVIE
} from '@/constants/constant';
import { formatDateTime } from '@/utils/utils';

import { PAGER } from '@/constants/event';
import Pager from '@/common/lib/Pager/Pager';

import AuthorBase from '@/components/Author/base/Author';

export default {
  name: 'FeedDetail',

  mixins: [AuthorBase],

  data() {
    return {
      pager: null,
      recommendList: []
    };
  },

  computed: {
    ...mapGetters([
      'articleInfo',
      'boardFeedList'
    ]),
    isDesign() {
      return this.$route.params.boardKey === CONFIG.NRZ.DESIGN_CARD_NO;
    },
    isVideo() {
      return this.$route.params.navKey === MENU_KEY.SHIPIN;
    },
    authorInfo() {
      const { articleInfo } = this;
      const user = this.getAuthorInfo(articleInfo.content);
      if (user.nickname && user.avatar) {
        return {
          nickname: user.nickname,
          avatar: user.avatar
        };
      }
      return {
        nickname: articleInfo.user.nickname,
        avatar: articleInfo.user.profileImg || DEFAULT_IMG
      };
    },
    modeClassify() {
      return MOD_CLASSIFY[this.articleInfo.genre || 'GUNFIGHT'];
    },
    modePattern() {
      return this.articleInfo.modType === null
        ? '-'
        : this.articleInfo.modType === 0
          ? '个人'
          : '团队';
    },
    modePlayer() {
      const { sandboxMeta } = this.articleInfo.ugcMeta;
      return sandboxMeta.maxUser ? `${sandboxMeta.maxUser}人` : '-';
    },
    modeTag() {
      const { ugcTagList } = this.articleInfo.articleTagInfo;
      const tags = [...ugcTagList.specialTag, ...ugcTagList.scoreTag];
      return tags.join('、') || '-';
    },
    scoreValue() {
      return (this.articleInfo.likeRate / 20).toFixed(1);
    },
    weixinCode() {
      const url = encodeURIComponent(document.location.href);
      return `http://zixuephp.net/inc/qrcode_img.php?url=${url}`;
    },
    mediaList() {
      return this.articleInfo.mediaList.map(item => ({
        ...item,
        id: item.mediaNo,
        bannerImageUrl: item.mediaUrl
      }));
    },
    movieList() {
      return this.articleInfo.mediaList.filter(item => item.mediaType === CONTENT_TYPE_MOVIE);
    },
    articleContent() {
      if (!this.isZiYuan) {
        const { content } = this.articleInfo;

        return this.movieList.reduce((result, item) => {
          const id = `movie-${item.mediaNo}`;

          return result.replace(
            /<span class="fr-video.*?><\/span>/,
            `<span class="movie" id="${id}"></span>`
          );
        }, content.replace(/\$\{(.+?)\}/g, ''));
      }
      return this.articleInfo.content;
    }
  },

  watch: {
    '$route.params.cardNo': {
      async handler() {
        this.init();
        await this.getInfo();
        this.getSearchList();

        if (this.movieList.length) {
          if (window.player) {
            window.player.destroy();
          }
          if (this.useMobileUI && this.isVideo) {
            this.getPlayer('video', this.articleInfo.mediaUrl);
          } else {
            this.movieList.forEach(item => {
              this.getPlayer(`movie-${item.mediaNo}`, item.mediaUrl);
            });
          }
        }
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions([
      'getCard',
      'initArticle',
      'getArticleInfo',
      'getArticleInfoByJson'
    ]),
    init() {
      this.recommendList = [];
    },
    async getInfo() {
      const { navKey, cardNo } = this.$route.params;
      const { communityNo } = this.$route.query;

      await this.getArticleInfoByJson({
        navKey,
        cardNo
      });
      // if (this.isZiYuan) {
      //   await this.getArticleInfo({
      //     cafe_key: CONFIG.WORKSHOP.CAFE_KEY,
      //     channel_key: CONFIG.CHANNEL_KEY,
      //     community_no: communityNo,
      //     card_no: cardNo,
      //     ...CARD_INFO_PARAMS
      //   });
      // } else {
      //   await this.getCard({
      //     card_no: cardNo,
      //     ...CARD_INFO_PARAMS
      //   });
      // }
    },
    getVid(url, vid = 'vid') {
      const urlSearch = url.split('?');
      const pstr = urlSearch[1].split('&');
      for (let i = pstr.length - 1; i >= 0; i--) {
        const tep = pstr[i].split('=');
        if (tep[0] === vid) {
          return tep[1];
        }
      }
      return false;
    },
    getPlayer(id, mediaUrl) {
      const url = this.getVid(mediaUrl);
      const height = this.useMobileUI
        ? (this.isVideo ? '211px' : '194px')
        : '346px';

      window.player = new Txplayer({
        containerId: id,
        vid: url,
        width: '100%',
        height,
        autoplay: true,
        useSVG: true,
        showLogo: true,
        muted: false,
        volume: 50,
        settings: {
          UiControl: {
            subPlugins: [
              'UiControlPlay',
              'UiShowTime',
              'UiVolume',
              'UiProgress',
              'UiWindowFullScreen'
            ]
          }
        }
      });
      // 错误处理
      window.player.on('error', err => {
        // console.log(err);
      });
    },
    formatDateTime,
    shareTo(type) {
      // 获取标题
      const ftitle = encodeURIComponent(this.articleInfo.title);
      // 获取图片
      const { previewUrl } = this.articleInfo;
      const defaultUrl = 'https://game.gtimg.cn/images/sgxq/cp/a20191128sgxqm/256-256.png';
      const flink = previewUrl && !(/fipe-unlimited/g.test(previewUrl)) ? previewUrl : defaultUrl;
      const pList = this.$refs.content.getElementsByTagName('p');
      const url = encodeURIComponent(document.location.href);
      let content = '';
      [...pList].some(dom => {
        if (dom.innerText.trim()) {
          content = dom.innerText;
          return true;
        }
        return false;
      });

      switch (type) {
        case 'qzone':
          window.open(`https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}?title=${ftitle}&pics=${flink}&summary=${content}`);
          break;
        case 'sina':
          window.open(`http://service.weibo.com/share/share.php?url=${url}&title=${ftitle}&pic=${flink}`);
          break;
        case 'qq':
          window.open(`http://connect.qq.com/widget/shareqq/index.html?url=${url}?title=${ftitle}&pics=${flink}&summary=${content}`);
          break;
        default: break;
      }
    },
    getSearchList() {
      const key = this.getSearchKey();
      const { params, query } = this.$route;

      if (key) {
        this.pager.setRequestOption({
          action: 'getBoardSearchList',
          resetAction: 'resetBoardFeedList',
          submitData: {
            fields: 'tags',
            q: key,
            filters: `ref_parent_card_maps.card_no:${params.boardKey}`,
            sorts: query.direction === 'latest' ? 'reg_dt:desc' : 'like_cnt:desc'
          }
        });
        this.pager.storeReset();
        this.pager.next();
      }
    },
    getSearchKey() {
      if (this.isZiYuan) {
        return this.articleInfo.tagList.join(',');
      }
      return this.articleInfo.tagList.hashTag.join(',');
    },
    getRecommendList() {
      const totalList = this.boardFeedList.filter(
        item => item.cardNo !== this.$route.params.cardNo
      );
      if (totalList.length <= 4) {
        this.recommendList = totalList;
      } else {
        this.recommendList = this.getRandomList(totalList);
      }
    },
    getRandomList(totalList) {
      const result = [];
      let num = 4;
      // 乘以5的原因是防止list循环完，result还没有push进4个元素
      for (let i = 0; i < totalList.length * 5; i++) {
        if (num > 0) {
          const ran = Math.floor(Math.random() * totalList.length);
          if (!result.includes(totalList[ran])) {
            result.push(totalList[ran]);
            num--;
          }
        } else {
          return result;
        }
      }
    },
    pagerEventSetting() {
      this.pager.on(PAGER.COMPLETE, response => {
        if (!response) {
          return;
        }
        const responseData = this.responseMapping(response);
        const { content } = responseData;
        if (content.length) {
          this.getRecommendList();
        }
      });
    },
    responseMapping(response) {
      if (response.content) {
        return this.communityDataMapping(response);
      }
      return '';
    },
    communityDataMapping(response) {
      const payload = this.pager.getSubmitData();
      return {
        content: response.content,
        lastPage: payload.size > response.content.length || response.last_page
      };
    }
  },
  created() {
    this.pager = new Pager();
    this.pagerEventSetting();
  },
  destroyed() {
    this.initArticle();
  }
};
</script>
